module.exports = __webpack_public_path__ + "static/media/Lens-Charm_TW.ecaf968b.png";